import { RELEASED, currentWindow, isSeasonalTheme, nextWindow } from "./seasons";

/**
 * The themes a picker should show, in order. Seasonal themes in season go first
 * with `until` = the last day of their window (the date the label shows).
 * Out of season a seasonal theme is hidden, except for the creator's current
 * theme (a resumed draft; no label) and for admins (`allSeasons`, labelled with
 * the next window's end). Everything else keeps its original order.
 */
export function orderedThemesFor(themes, now, { currentTheme = null, allSeasons = false, released = RELEASED } = {}) {
  const seasonal = [];
  const rest = [];
  for (const key of Object.keys(themes)) {
    if (!isSeasonalTheme(key, released)) {
      rest.push({ key, until: null });
      continue;
    }
    const live = currentWindow(key, now, released);
    if (live) seasonal.push({ key, until: live.end });
    else if (allSeasons) seasonal.push({ key, until: nextWindow(key, now, released)?.end ?? null });
    else if (key === currentTheme) seasonal.push({ key, until: null });
  }
  // Soonest-ending first; a kept current theme (no date) goes last among them.
  seasonal.sort((a, b) => (a.until ? a.until.getTime() : Infinity) - (b.until ? b.until.getTime() : Infinity));
  return [...seasonal, ...rest];
}
